module.exports = __webpack_public_path__ + "static/media/aryYoung.b1f1a312.jpg";